// JustEasySEO — Button (M144 Fase 1).
// Varianten: primary (petrol vulling), secondary (petrol outline),
// tertiary (ghost / tekstueel), destructive (rood outline).
// Ondersteunt loading-state met spinner + disabled state.
import React from "react";
import { Loader2 } from "lucide-react";

const BASE = "inline-flex items-center justify-center gap-2 font-medium " +
  "transition-colors duration-exec select-none rounded-btn " +
  "focus-visible:outline-2 focus-visible:outline-accent-teal " +
  "disabled:opacity-50 disabled:cursor-not-allowed";

const SIZE = {
  sm: "h-8 px-3 text-sm",
  md: "h-10 px-4 text-sm",
  lg: "h-12 px-5 text-base",
};

const VARIANT = {
  primary: "bg-accent-teal text-white hover:bg-accent-teal-dim " +
           "shadow-card hover:shadow-card-hover",
  secondary: "border border-accent-teal text-accent-teal " +
             "hover:bg-[color:var(--accent-teal-soft)] bg-white",
  tertiary: "text-accent-teal hover:bg-[color:var(--accent-teal-soft)] " +
            "border border-transparent",
  destructive: "border border-neg-red text-neg-red hover:bg-neg-red/5 bg-white",
};

export function Button({
  variant = "primary",
  size = "md",
  loading = false,
  disabled = false,
  leftIcon = null,
  rightIcon = null,
  children,
  className = "",
  ...rest
}) {
  return (
    <button
      disabled={disabled || loading}
      className={`${BASE} ${SIZE[size]} ${VARIANT[variant]} ${className}`}
      {...rest}
    >
      {loading ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : (
        leftIcon
      )}
      <span>{children}</span>
      {rightIcon}
    </button>
  );
}

export default Button;
